import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("onusa_cookie_consent")) setShow(true);
  }, []);
  const decide = (val) => {
    localStorage.setItem("onusa_cookie_consent", val);
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-[#1D1D1B] text-[#F7F5F1] p-5" data-testid="cookie-consent">
      <div className="onusa-container flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs text-[#F7F5F1]/80 max-w-2xl leading-relaxed">
          We gebruiken essentiële cookies om deze winkel te laten werken. Analytische cookies worden alleen geladen met jouw toestemming. Zie ons <a href="/cookies" className="underline">Cookiebeleid</a>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => decide("essential")} className="label-x border border-[#F7F5F1]/40 px-5 py-2.5" data-testid="cookie-essential">ALLEEN ESSENTIEEL</button>
          <button onClick={() => decide("all")} className="label-x bg-[#F7F5F1] text-[#1D1D1B] px-5 py-2.5" data-testid="cookie-accept">ALLES ACCEPTEREN</button>
        </div>
      </div>
    </div>
  );
}
